import React from 'react';

const FormField = ({
  id,
  name,
  label,
  type = 'text',
  value,
  onChange,
  onBlur,
  error,
  required = false,
  disabled = false,
  autoComplete,
  placeholder,
  inputMode,
  hint,
}) => {
  const fieldId = id || name;
  const errorId = error ? `${fieldId}-error` : undefined;
  const hintId = hint ? `${fieldId}-hint` : undefined;
  const describedBy = [errorId, hintId].filter(Boolean).join(' ') || undefined;

  return (
    <div className={`tf-field${error ? ' tf-field--invalid' : ''}`}>
      {label && (
        <label htmlFor={fieldId} className="tf-field__label">
          {label}{required && <span aria-hidden="true" className="tf-field__required"> *</span>}
        </label>
      )}
      <input
        id={fieldId}
        name={name}
        type={type}
        value={value ?? ''}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        required={required}
        autoComplete={autoComplete}
        inputMode={inputMode}
        placeholder={placeholder}
        aria-invalid={!!error}
        aria-required={required || undefined}
        aria-describedby={describedBy}
        className="tf-field__input"
      />
      {hint && !error && (
        <span id={hintId} className="tf-field__hint">{hint}</span>
      )}
      {error && (
        <span id={errorId} className="tf-field__error" role="alert">{error}</span>
      )}
    </div>
  );
};

export default FormField;
